module.exports = __webpack_public_path__ + "static/media/2020-07-24 Takhzyro IB-0016_reduction shelf life_FI.d350a5c3.pdf";